import { debounce } from 'lodash';
import { mapActions } from 'vuex';
import { getViewportData } from 'util/dom/mq';


export default {
    methods: {
        ...mapActions(['setViewport']),
        updateViewport: debounce(function() {
            const isPrint = window.matchMedia('print').matches;

            this.setViewport({
                type: isPrint ? 'print' : 'screen',
                width: window.innerWidth,
                height: window.innerHeight,
                mq: getViewportData(),
            });
        }, 100, {
            maxWait: 1000,
        }),
    },
    mounted() {
        this.updateViewport();
        window.addEventListener('resize', this.updateViewport);
        window.addEventListener('orientationchange', this.updateViewport);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateViewport);
        window.removeEventListener('orientationchange', this.updateViewport);
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/vuex/modules/viewport/mixin.js